import React from "react"
import EditorPane from "components/CanvasEditor/EditorPane"
import Select from "components/ReactHookForm/Select"
import TextArea from "components/ReactHookForm/TextArea"
import { Control } from "react-hook-form"
import { BADGE_TEXT_SOURCE_LABELS, BadgeTextSource } from "sharedTypes/badge"
import { BadgeElementFormValues } from "components/BadgeBuilder/Panels/EditorPanel/BadgeSidePanelForm"

type Props = {
  control: Control<BadgeElementFormValues>
  variant: "static" | "field"
}

const BadgeTextContentFields = ({ control, variant }: Props) => {
  const fieldSourceOptions = Object.values(BadgeTextSource).map((source) => ({
    label: BADGE_TEXT_SOURCE_LABELS[source],
    value: source,
  }))

  return (
    <EditorPane title={variant === "static" ? "Static Text" : "Dynamic Field"}>
      {variant === "static" ? (
        <TextArea
          name="text"
          control={control}
          placeholder="Enter your text"
          h={20}
        />
      ) : (
        <Select
          name="source"
          control={control}
          options={fieldSourceOptions}
          mb={0}
          size="sm"
        />
      )}
    </EditorPane>
  )
}

export default BadgeTextContentFields
